module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Alarm-clock-dc7c736b55b8de2fb3be19993d5993bd.svg";